import {useEffect} from "react";

import {ReservationModal} from "../../../reservation/components/ReservationModal";
import {useAppSelector} from "../../../store/hooks";

interface IProps {
    // closes the registration flow
    onClose: () => void;
}

// The reservation step of the registration flow - the request survives the registration and phone steps in the flow state
export const ReservationStep = (props: IProps) => {
    const {onClose} = props;

    const request = useAppSelector((state) => state.registrationFlow.reservationRequest);
    const authPlacement = useAppSelector((state) => state.registrationFlow.amplitudePlacement);

    useEffect(() => {
        // nothing to reserve - do not leave an active flow without a modal
        if (!request) {
            onClose();
        }
    }, [request]);

    if (!request) {
        return null;
    }

    return <ReservationModal request={request} authPlacement={authPlacement} onClose={onClose} />;
};
import {useEffect} from "react";

import {ReservationModal} from "../../../reservation/components/ReservationModal";
import {useAppSelector} from "../../../store/hooks";

interface IProps {
    // closes the registration flow
    onClose: () => void;
}

// The reservation step of the registration flow - the request survives the registration and phone steps in the flow state
export const ReservationStep = (props: IProps) => {
    const {onClose} = props;

    const request = useAppSelector((state) => state.registrationFlow.reservationRequest);
    const authPlacement = useAppSelector((state) => state.registrationFlow.amplitudePlacement);

    useEffect(() => {
        // nothing to reserve - do not leave an active flow without a modal
        if (!request) {
            onClose();
        }
    }, [request]);

    if (!request) {
        return null;
    }

    return <ReservationModal request={request} authPlacement={authPlacement} onClose={onClose} />;
};
